module.exports = __webpack_public_path__ + "img/payment-method.285fc828.png";